import { collection, doc, updateDoc } from "firebase/firestore";
import { db } from "firebaseDb"; // adjust to your Firebase config

/**
 * Updates only the `coordinates` field for each row document in Firestore.
 * @param {Array} rows - Array of row objects containing `id` and `coordinates`.
 * @param {string} orchardId - Orchard ID (e.g. "MOL")
 * @param {string} blockId - Block ID (e.g. "B2")
 */
const updateRowCoordinates = async (rows, orchardId, blockId) => {
  try {
    const rowsCollection = collection(db, "OrchardMaps", orchardId, "Blocks", blockId, "Rows");

    const updatePromises = rows.map(async (row) => {
      const rowRef = doc(rowsCollection, row.id);
      await updateDoc(rowRef, { coordinates: row.coordinates }, { merge: true });
    });

    await Promise.all(updatePromises);

    console.log(`✅ Updated coordinates for ${rows.length} rows in ${orchardId} Block ${blockId}`);
  } catch (error) {
    console.error("❌ Error updating row coordinates:", error);
  }
};

export default updateRowCoordinates;
